var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.7471 20.14L16.9475 14.3155C17.7965 12.9726 18.2867 11.3822 18.2867 9.67808C18.2876 4.894 14.4096 1 9.64335 1C4.87709 1 1 4.894 1 9.679C1 14.4649 4.87709 18.3589 9.64335 18.3589C11.2574 18.3589 12.7664 17.9125 14.0609 17.137L19.8998 23L22.7471 20.14ZM4.22072 9.679C4.22072 6.67875 6.6536 4.23583 9.64244 4.23583C12.6322 4.23583 15.0651 6.67783 15.0651 9.679C15.0651 12.6811 12.6322 15.1231 9.64244 15.1231C6.6536 15.1231 4.22072 12.6811 4.22072 9.679Z","fill":"currentColor"}));
}

Search.defaultProps = {"viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = Search;

Search.default = Search;
